import { useReducer } from 'react';

export type ActivationMode = 'activate' | 'deactivate';

type ModalState = {
  isCreateModalOpen: boolean;
  isEditModalOpen: boolean;
  isDeleteModalOpen: boolean;
  isActivationModalOpen: boolean;
  activationMode: ActivationMode;
};

type ModalAction =
  | { type: 'OPEN_CREATE' }
  | { type: 'OPEN_EDIT' }
  | { type: 'OPEN_DELETE' }
  | { type: 'OPEN_ACTIVATE' }
  | { type: 'OPEN_DEACTIVATE' }
  | { type: 'CLOSE' };

const INITIAL_STATE: ModalState = {
  isCreateModalOpen: false,
  isEditModalOpen: false,
  isDeleteModalOpen: false,
  isActivationModalOpen: false,
  activationMode: 'activate',
};

const modalReducer = (_state: ModalState, action: ModalAction): ModalState => {
  switch (action.type) {
    case 'OPEN_CREATE':
      return { ...INITIAL_STATE, isCreateModalOpen: true };
    case 'OPEN_EDIT':
      return { ...INITIAL_STATE, isEditModalOpen: true };
    case 'OPEN_DELETE':
      return { ...INITIAL_STATE, isDeleteModalOpen: true };
    case 'OPEN_ACTIVATE':
      return { ...INITIAL_STATE, isActivationModalOpen: true, activationMode: 'activate' };
    case 'OPEN_DEACTIVATE':
      return { ...INITIAL_STATE, isActivationModalOpen: true, activationMode: 'deactivate' };
    case 'CLOSE':
      return INITIAL_STATE;
  }
};

export const useConnectorModals = () => {
  const [state, dispatch] = useReducer(modalReducer, INITIAL_STATE);

  const openCreateModal = () => dispatch({ type: 'OPEN_CREATE' });
  const openEditModal = () => dispatch({ type: 'OPEN_EDIT' });
  const openDeleteModal = () => dispatch({ type: 'OPEN_DELETE' });
  const openActivateModal = () => dispatch({ type: 'OPEN_ACTIVATE' });
  const openDeactivateModal = () => dispatch({ type: 'OPEN_DEACTIVATE' });
  const closeModal = () => dispatch({ type: 'CLOSE' });

  return {
    ...state,
    openCreateModal,
    openEditModal,
    openDeleteModal,
    openActivateModal,
    openDeactivateModal,
    closeModal,
  } as const;
};
